<template>
  <v-container>

    <v-data-table
        :headers="headers"
        :items="weapons"
        :items-per-page="500"
        class="elevation-1"
    >

      <template v-slot:item.baseDamageType="{ item }">
        <v-img :src="resolveDamageTypeAsset(item.baseDamageType)" height="16px" width="16px"></v-img>
      </template>


      <template v-slot:item.extraDamageType="{ item }">
        <v-img :src="resolveDamageTypeAsset(item.extraDamageType)" height="16px" width="16px" v-if="item.extraDamage > 0"></v-img>
      </template>

      <template v-slot:item.extraDamage="{ item }">
        {{ (item.extraDamage > 0) ? item.extraDamage : '-' }}
      </template>

    </v-data-table>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import CombatService from "../services/CombatService";
import DamageType from "../models/DamageType"

export default {
  name: "Weapons",
  components: { },
  computed: {
    ...mapGetters("entities/weapons",["all"]),
    headers () {
        const headers = [
          {
            text:'Name',
            value:'name'
          },
          {
            text:'Damage Type',
            value:'baseDamageType'
          },
          {
            text:'Damage Min',
            value:'baseDamageMin'
          },
          {
            text:'Damage Max',
            value:'baseDamageMax'
          },
          {
            text:'Extra Damage Type',
            value:'extraDamageType'
          },
          {
            text:'Extra Damage',
            value:'extraDamage'
          },
                              {
            text:'Speed',
            value:'speed'
          },
                              {
            text:'Critical Chance',
            value:'criticalChance'
          },
                              {
            text:'Critical Multiplicator',
            value:'criticalMultiplicator'
          },
        ] 

        DamageType.ALL.forEach(damageType => {
          headers.push({text:'DPS\n(' + damageType + ')', value:'damagePerSecond' + damageType})
        })

        
        return headers;
    },
    weapons() {
      const weapons = this.all
      weapons.forEach(weapon => {
        const damage = CombatService.calculateDamagePerSecond(weapon);
        DamageType.ALL.forEach(damageType => {
          weapon['damagePerSecond' + damageType] = damage.getByDamageType(damageType);
        })
      });
      return weapons;
    }
  },
  methods: {
    ...mapActions([]),
    resolveDamageTypeAsset(damageType) {
      var images = require.context('../assets/', false, /\.png$/)
      return images('./damage-type-' + damageType.toLowerCase() +  '-16px.png')
    }
  },
};
</script>
